import { atom, useAtomValue, useSetAtom } from 'jotai';

/**
 * 대화 복원 여부 결정 신호.
 *
 * 대화 복원은 문항 복원("이어 만들기")과 결합돼야 한다 — 턴 요청이 매번 폼의
 * questions 를 통째로 실어보내므로, 대화만 복원되면 "문항 0개 + 10문제 만들었다는
 * 이력" 불일치가 생기고 이후 편집 턴이 없는 문항을 건드린다.
 *
 * 결정을 내리는 `BuildPageInitializer` 는 `AiBuilderChatProvider` 바깥에 있어
 * 채팅 컨텍스트를 직접 쓸 수 없다. 그래서 기본 jotai store 의 atom 하나로 신호만
 * 흘린다(`usePersistButtonVisible` 과 같은 방식).
 *
 * - `pending`: 아직 결정 전. 복원 대상 스냅샷이 있으면 세션 생성을 보류한다.
 * - `accepted`: 문항을 이어 만들기로 했다 → 대화도 복원.
 * - `rejected`: 초안을 버렸다 → 대화 스냅샷도 폐기.
 */
export type AiBuilderChatRestoreDecision = 'pending' | 'accepted' | 'rejected';

const aiBuilderChatRestoreDecisionAtom =
  atom<AiBuilderChatRestoreDecision>('pending');

export const useAiBuilderChatRestoreDecision = () =>
  useAtomValue(aiBuilderChatRestoreDecisionAtom);

export const useSetAiBuilderChatRestoreDecision = () =>
  useSetAtom(aiBuilderChatRestoreDecisionAtom);
